// extracted by mini-css-extract-plugin
module.exports = {"content":"content--1fO5Z","main_content":"main_content--2r37W","apply_padding":"apply_padding--3Jkft","apply_width_limit":"apply_width_limit--HK3Au"};